export default {"src":"/_next/static/media/delivery.cc4116c7.svg","height":33,"width":33};